var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Link } from '@honda-canada/design-system-react';
import themeStyles from './TimelineSharedUI.styles';
import { onTimelineNavClick } from '../service/utils';
var TimelineNavigationLink = themeStyles.apply(Link, 'TimelineNavigationLink');
var TimelineNavigationItem = function (_a) {
    var value = _a.value, isActive = _a.isActive, href = _a.href, navSection = _a.navSection, onClick = _a.onClick, dataTestId = _a.dataTestId, componentParameters = _a.componentParameters;
    var onNavClick = function (event) {
        if (onClick) {
            onClick();
        }
        event.preventDefault();
        onTimelineNavClick(href);
    };
    return (React.createElement(TimelineNavigationLink, __assign({ as: "button", "data-testid": dataTestId, onClick: onNavClick, navSection: navSection, isActive: isActive }, componentParameters), value));
};
export default TimelineNavigationItem;
